/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Charts_LabelInputs */

const en_us2_exercise_sheet_charts_label = /** @type {(inputs: Exercise_Sheet_Charts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workouts`)
};

const pt_br2_exercise_sheet_charts_label = /** @type {(inputs: Exercise_Sheet_Charts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos`)
};

const es_419_exercise_sheet_charts_label = /** @type {(inputs: Exercise_Sheet_Charts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamientos`)
};

const pt_pt2_exercise_sheet_charts_label = /** @type {(inputs: Exercise_Sheet_Charts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos`)
};

const fr_fr2_exercise_sheet_charts_label = /** @type {(inputs: Exercise_Sheet_Charts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances`)
};

const de_de2_exercise_sheet_charts_label = /** @type {(inputs: Exercise_Sheet_Charts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings`)
};

const it_it2_exercise_sheet_charts_label = /** @type {(inputs: Exercise_Sheet_Charts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamenti`)
};

/**
* | output |
* | --- |
* | "Workouts" |
*
* @param {Exercise_Sheet_Charts_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_charts_label = /** @type {((inputs?: Exercise_Sheet_Charts_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Charts_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_charts_label(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_charts_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_charts_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_charts_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_charts_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_charts_label(inputs)
	return en_us2_exercise_sheet_charts_label(inputs)
});
export { exercise_sheet_charts_label as "exercise-sheet.charts_label" }